
import React, { useState, useEffect } from 'react';
import { Scissors, Droplet, Wind, Sparkles, Package, Flower2, Plus, Loader } from 'lucide-react';
import { API_BASE } from '../config';

const ICON_MAP = { 
    'Scissors': Scissors, 
    'Droplet': Droplet, 
    'Wind': Wind, 
    'Sparkles': Sparkles,
    'Package': Package,
    'Flower2': Flower2,
    'Plus': Plus
};

export default function Services({ t, lang }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/services`)
      .then(res => res.json())
      .then(data => setServices(data))
      .catch(err => console.error("Error fetching services:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">{t.services.title}</h2>
      
      {loading ? (
        <div className="flex justify-center py-10">
          <Loader className="animate-spin h-12 w-12 text-pink-600" />
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = ICON_MAP[service.icon] || Scissors;
            const name = service[`name_${lang}`] || service.name_fr || service.name || 'Service';
            const description = service[`description_${lang}`] || service.description_fr || service.description || '';

            return (
              <div key={service.id} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col items-center text-center">
                <div className="bg-pink-50 p-4 rounded-full mb-4"><IconComponent className="h-10 w-10 text-pink-600" /></div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{name}</h3>
                <p className="text-gray-600 mb-4 flex-grow">{description}</p>
                <div className="mt-auto">
                  <p className="text-2xl font-bold text-pink-600">{service.price}€</p>
                  <p className="text-sm text-gray-400 mt-1">{service.duration} min</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
